<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> {{ $t('str.manage-fault-finding-category') }}
            <div class="card-header-actions">
              <router-link to="/content/fault-finding-category" class="card-header-action btn-setting">
                <buttons button-type="back" />
              </router-link>
            </div>
          </div>
          <b-form @submit.prevent="saveData">
            <b-row>
              <b-col sm="12">
                <table class="table">
                  <tbody>
                    <template v-for="lang in langArr">
                      <tr>
                        <th colspan="2">
                          <h4>{{ $t('str.'+lang) }}</h4>
                        </th>
                      </tr>
                      <tr>
                        <th scope="row">{{$t('str.name')}}</th>
                        <td>
                          <template v-if="lang === 'en'">
                            <b-form-input type="text" name="name"
                              :class="{ 'form-control': true, 'is-invalid': errors.has('name') }" id="name"
                              v-validate="{ required: true }" v-model="addData['name_'+lang]" />
                            <span class="invalid-feedback">{{ errors.first('name') }}</span>
                          </template>
                          <template v-else>
                            <b-form-input type="text" :name="'name_'+lang" :id="'name_'+lang"
                              :class="{ 'form-control': true, 'rtl': lang == 'ar' || lang == 'fa' }"
                              v-model="addData['name_'+lang]" />
                          </template>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <buttons button-type="submit" />
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

import Buttons from '@/views/component/Buttons'

import * as Auth from '@/shared/auth'
import * as helper from '@/shared/helper'

const envi = process.env

export default {
  components: {
    'buttons': Buttons
  },
  data() {
    return {
      id: this.$route.params.id,
      langArr: envi.VUE_APP_LANG.split(','),
      addData: {
        name_en: '',
        name_zh: '',
        name_bn: '',
        name_ms: '',
        name_my: '',
        name_th: '',
        name_tl: '',
        name_vi: '',
        name_ar: '',
        name_es: '',
        name_ja: '',
        name_hi: '',
        name_fr: '',
        name_pt: '',
        name_fa: ''
      }
    }
  },
  methods: {
    async getData() {
      this.$auth.checkSession()
      var faultFindingCategoryId = this.id

      if (faultFindingCategoryId > 0) {
        try {
          var getData = await axios.get(`${envi.VUE_APP_API_URL}/FaultFindingCategory/${faultFindingCategoryId}`, {
            headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
          })

          for (let i = 0; i < this.langArr.length; i++) {
            this.addData['name_' + this.langArr[i]] = getData.data.data['name_' + this.langArr[i]]
          }
        } catch (e) {
          console.log('err', e.response)
          if (e.response) {
            this.$router.push('/pages/404')
          }
        }
      }
    },
    async saveData() {
      this.$auth.checkSession()
      if (this.$validator.validateAll()) {
        var method = 'post'
        var url = `${envi.VUE_APP_API_URL}/FaultFindingCategory/`
        if (this.id > 0) {
          method = 'patch'
          url = `${url}${this.id}`
        }

        try {
          var result = await axios[method](url, this.addData, {
            headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
          })

          this.$toast.success(result.data.meta.message, '', {
            position: 'topCenter'
          })

          if (this.id == 0)
            this.$router.push('/content/fault-finding-category')
        } catch (e) {
          if (Array.isArray(e.response.data.meta.error)) {
            e.response.data.meta.error.forEach((err) => {
              this.$toast.error(err.msg, e.response.data.meta.message, {
                position: 'topCenter'
              })
            })
          } else if (typeof e.response.data.meta.error === 'string') {
            this.$toast.error(e.response.data.meta.message, e.response.data.meta.error, {
              position: 'topCenter'
            })
          }
        }
      }
    }
  },
  created() {
    this.getData()
  }
}
</script>